import { EmptyState, Flex } from "@ir/ui";

const ShareLinkExpiredView = () => {
  return (
    <Flex justifyContent="center" align="center" className="min-vh-100 p-4">
      <EmptyState
        title="Link expired"
        description="This link has expired. Please request a new link from the dashboard owner."
      />
    </Flex>
  );
};

export default ShareLinkExpiredView;
